import ar from './ar/';
import en_US from './en-US/';
import es from './es/';
import ja_JP from './ja-JP/';
import nl from './nl/';
import pt_BR from './pt-BR/';
import vi from './vi/';
import zh from './zh/';

export default {
  ...ar,
  ...en_US,
  ...es,
  ...ja_JP,
  ...nl,
  ...pt_BR,
  ...vi,
  ...zh,
};